var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import LazyLoad from 'react-lazyload';
import * as React from 'react';
import { UitkCardPlaceholder } from 'uitk-react-cards';
/**
 * This component simplified lazy loading
 */
export var SimpleLazyLoadWrapper = React.forwardRef(function SimpleLazyLoadWrapper(_a, ref) {
  var children = _a.children,
    _b = _a.placeholder,
    placeholder = _b === void 0 ? React.createElement(UitkCardPlaceholder, null) : _b,
    props = __rest(_a, ["children", "placeholder"]);
  return React.createElement(LazyLoad, __assign({
    once: true,
    placeholder: placeholder
  }, props, {
    ref: ref
  }), children);
});
SimpleLazyLoadWrapper.displayName = 'SimpleLazyLoadWrapper';